// extracted by mini-css-extract-plugin
module.exports = {"tuCibilTermsContent":"_1OzJg"};